import './App.css';
import { useEffect } from "react";
import Header from './components/header/header';
import Games from './views/Games/Games'
import Login from './views/Login/Login';
import Profile from './views/Profile/Profile';
import NewsLetter from './views/NewsLetter/NewsLetter';
import Administrative from './views/Administrative/Administrative';
import Marketing from './views/Marketing/Marketing';
import { Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchMe, logOut } from "./redux/authSlice";
import { hasRole, UNAUTHORIZED_EVENT } from "./utils/api";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const employee = useSelector((state) => state.auth.employee);
  const isLogin = location.pathname === "/";

  // Refresca el perfil al abrir la app con una sesión guardada.
  useEffect(() => {
    if (isAuthenticated) dispatch(fetchMe());
  }, [isAuthenticated, dispatch]);

  // Si la API responde 401 (token vencido o inválido) se cierra la sesión.
  useEffect(() => {
    const handleUnauthorized = () => {
      dispatch(logOut());
      navigate("/", { replace: true });
    };
    window.addEventListener(UNAUTHORIZED_EVENT, handleUnauthorized);
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, handleUnauthorized);
  }, [dispatch, navigate]);

  // Muestra la vista si hay sesión y el rol requerido; si no, redirige.
  const guard = (element, ...roles) => {
    if (!isAuthenticated) return <Navigate to="/" replace />;
    if (roles.length && !hasRole(employee, ...roles)) return <Navigate to="/Profile" replace />;
    return element;
  };

  return (
    <>
      {isAuthenticated && !isLogin && <Header />}
      {isAuthenticated && !isLogin && <div className="vertical-separator"></div>}
      <section className={!isAuthenticated || isLogin ? 'container-login' : 'container'}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Profile" element={guard(<Profile />)} />
          <Route path="/Games" element={guard(<Games />, "games")} />
          <Route path="/NewsLetter" element={guard(<NewsLetter />, "marketing")} />
          <Route path="/Marketing" element={guard(<Marketing />, "marketing")} />
          <Route path="/Marketing/Accounts" element={guard(<Marketing />, "marketing")} />
          <Route path="/Administrative" element={guard(<Administrative />, "hr")} />
          <Route path="*" element={<Navigate to={isAuthenticated ? "/Profile" : "/"} replace />} />
        </Routes>
      </section>
    </>
  );
}

export default App;
